<ng-template #templateRef>
  @if (hasContent || canAcceptRowsOrder) {
    <div class="flex justify-content-between flex-wrap">
      <div class="inline-flex align-items-center">
        <ng-container *ngTemplateOutlet="data.captionHeaderTemplate"></ng-container>
        <ng-container *ngTemplateOutlet="data.leftButtonsTemplate; context: buttonsContext">
        </ng-container>
        @if (tableSettings.hasAdvancedFilters) {
          <button pButton
                  icon="pi pi-sliders-h"
                  class="p-button-outlined"
                  [label]="filterButtonLabel"
                  (click)="showAdvancedFilter()"></button>
        }
        @if (data.canClear()) {
          <button pButton
                  class="p-button-text"
                  label="Discard"
                  i18n-label
                  (click)="clearAll()"></button>
        }
      </div>
      <div class="inline-flex align-items-center gap-3">
        @if (selection.length) {
          <div class="font-normal"
               i18n>Selected {{selection.length}} record{{selection.length > 1 ? 's': ''}}</div>
        }
        @if (buttonsContext.pageInfo && tableSettings.export) {
          <p-splitButton #exportBtn
                         (onClick)="exportBtn.onDropdownButtonClick($event)"
                         (onDropdownClick)="setExportButtonOptions()"
                         [model]="exportButtonOptions"
                         [disabled]="buttonsContext.pageInfo.count === 0 || buttonsContext.pageInfo.filteredCount === 0"
                         [icon]="exportInProcess ? 'pi pi-spin pi-spinner' : 'far fa-file-excel'"
                         label="Export"
                         i18n-label>
          </p-splitButton>
        }
        @if (canAcceptRowsOrder) {
          <p-button label="Save"
                    i18n-label
                    [disabled]="orderingInProcess"
                    [loading]="orderingInProcess"
                    (onClick)="onSubmitRowsOrder(true)">
          </p-button>
          <p-button label="Discard"
                    i18n-label
                    [disabled]="orderingInProcess"
                    styleClass="p-button-outlined"
                    (onClick)="onSubmitRowsOrder(false)">
          </p-button>
        }
        <ng-container *ngTemplateOutlet="data.rightButtonsTemplate; context: buttonsContext">
        </ng-container>
        @if (tableSettings.toggleColumns?.canToggleColumns) {
          <span [ngClass]="{ 'p-float-label': !toggleColumnsSettings.toggleDropdownAsLink }">
            <p-floatlabel variant="on">
              <p-multiSelect inputId="columnsDropdown"
                             [showHeader]="!toggleColumnsSettings.toggleDropdownAsLink"
                             [options]="settingsColumns"
                             [(ngModel)]="selectedColumns"
                             (onChange)="onSelectedColumnsChanged($event)"
                             (onPanelHide)="onHideColumnMultiselect()"
                             dataKey="field"
                             optionLabel="header"
                             appendTo="body"
                             [selectedItemsLabel]="toggleColumnsSettings.selectedItemsLabel"
                             i18n-selectedItemsLabel
                             [placeholder]="toggleColumnsSettings.defaultLabel"
                             [styleClass]="toggleColumnsSettings.multiselectStyleClass"
                             [dropdownIcon]="toggleColumnsSettings.dropdownIcon"
                             [maxSelectedLabels]="toggleColumnsSettings.maxSelectedLabels"
                             i18n-placeholder>
              </p-multiSelect>
              @if (!toggleColumnsSettings.toggleDropdownAsLink) {
                <label for="columnsDropdown"
                       i18n>Show/Hide columns</label>
              }
            </p-floatlabel>
          </span>
        }
      </div>
    </div>
  }
</ng-template>